export default class SubscriptionLibraryUpsertRequest {
    organizationId: string;
    libraryId: string;
    seats: number;
    isActive: boolean;
    expirationDate: string;

    constructor(organizationId: string, libraryId: string, seats: number, isActive: boolean, expirationDate: string) {
        this.organizationId = organizationId
        this.libraryId = libraryId
        this.seats = seats
        this.isActive = isActive,
        this.expirationDate = expirationDate
      }
}